module.exports = __webpack_public_path__ + "assets/bingqilin.376513df.svg";